import type { LabelType } from '@/defs/misc'

export const NUMBER_OPERATORS = ['atLeast', 'atMost', 'equal'] as const
export type NumberOperatorsType = (typeof NUMBER_OPERATORS)[number]
export const isNumberOperatorsType = (operator?: string): operator is NumberOperatorsType =>
  NUMBER_OPERATORS.includes(operator as NumberOperatorsType)
export const NUMBER_OPERATOR_LABELS: LabelType<NumberOperatorsType, { labelLong: string }> = {
  atLeast: { label: '≥', labelLong: 'At least' },
  atMost: { label: '≤', labelLong: 'At most' },
  equal: { label: '=', labelLong: 'Exactly' },
}

export const SET_OPERATORS = ['include', 'exclude'] as const
export type SetOperatorsType = (typeof SET_OPERATORS)[number]
export const isSetOperatorsType = (operator?: string): operator is SetOperatorsType =>
  SET_OPERATORS.includes(operator as SetOperatorsType)
export const SET_OPERATOR_LABELS: LabelType<SetOperatorsType> = {
  exclude: { label: 'Exclude' },
  include: { label: 'Include' },
}
